module.exports = __webpack_public_path__ + "img/pending.15fae96b.svg";